import React, { useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { PublicRoute } from "./routes/PublicRoute";
import { userState } from "./Services/RecoilAtoms";
import { PrivateRoute } from "./routes/PrivateRoute";

const App = () => {
  const user = useRecoilValue(userState);
  

  const router = createBrowserRouter([
    user?.data?.info?.id ? PrivateRoute() : {},
    ...PublicRoute(),
  ]);

  return <RouterProvider router={router} />;
};

export default App;
